module.exports = __webpack_public_path__ + "static/media/arabica.585a100e.jpg";